import { cn } from "@/lib/utils";
import { AlertCircle, Loader, type LucideIcon } from "lucide-react";
import type { FpToolCallMessagePart } from "../../../../../../schemas/codegen";

type SimpleMessageCardProps = {
  icon: LucideIcon;
  title: React.ReactNode;
  additionalContent?: React.ReactNode;
  className?: string;
} & Pick<FpToolCallMessagePart, "status">;

export function SimpleMessageCard({
  status,
  icon: Icon,
  title,
  additionalContent,
  className,
}: SimpleMessageCardProps) {
  const statusIcon =
    status === "pending" ? (
      <Loader className="w-3 h-3 animate-spin" />
    ) : status === "error" ? (
      <AlertCircle className="w-3 h-3 text-warning" />
    ) : null;

  return (
    <div
      className={cn(
        "flex items-center gap-2 px-3 py-2 rounded-md border transition-colors min-w-0 first:-mt-1",
        className,
      )}
    >
      <Icon className="w-4 h-4 flex-shrink-0 text-muted-foreground" />
      <div className="flex-1 min-w-0">
        <div className="flex flex-col gap-0.5">
          <span className="text-sm font-medium">{title}</span>
          {additionalContent}
        </div>
      </div>
      <div className="flex-shrink-0">{statusIcon}</div>
    </div>
  );
}
